import type { RouteRecordRaw } from "vue-router";

export const documentQaRoutes: RouteRecordRaw[] = [
  // AI Document Q&A
  // Static routes before dynamic :id
  {
    path: "/ai/document_qas",
    name: "ai_document_qa-index",
    component: () => import("./document_qas/DocumentQaPage.vue"),
    meta: {
      title: "tools_meta.ai_document_qas_prefix",
    },
  },
  {
    path: "/ai/document_qas/history",
    name: "ai-document-qa-history",
    component: () => import("./document_qas/history.vue"),
    meta: {
      title: "tools_meta.ai_document_qas_prefix",
    },
  },
  {
    path: "/ai/document_qas/info",
    name: "ai_document_qa-info",
    component: () => import("./document_qas/info.vue"),
    meta: {
      title: "tools_meta.ai_document_qas_prefix",
    },
  },
  {
    path: "/ai/document_qas/:id",
    name: "ai_document_qa-show",
    component: () => import("./document_qas/DocumentQaDetailPage.vue"),
    meta: {
      title: "tools_meta.ai_document_qas_prefix",
    },
  },
];
